import { render, staticRenderFns } from "./follow-record.pug?vue&type=template&id=06f4c5ad&lang=pug&"
import script from "./follow-record.ts?vue&type=script&lang=ts&"
export * from "./follow-record.ts?vue&type=script&lang=ts&"
import style0 from "./follow-record.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports